// The content has be scaled down to fit.
export const PDF_SCALE = 0.5185;

// Add this amount to the PDF height, to prevent a possible page break
export const PDF_OFFSET_VALUE = 70;

// A4 at 72 DPI.
export const PDF_DEFAULT_HEIGHT = 842;
export const PDF_DEFAULT_WIDTH = 595;
